import { useState, useRef } from 'react';
import { Popup } from '@progress/kendo-react-popup';

interface Props {
  unmatchedCriteria: string[];
}

export function UnmatchedCriteriaTooltip({ unmatchedCriteria }: Props) {
  const anchorRef = useRef<HTMLSpanElement>(null);
  const [show, setShow] = useState(false);

  if (!unmatchedCriteria.length) return null;

  return (
    <>
      <span
        ref={anchorRef}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'help',
          color: '#94a3b8',
          flexShrink: 0,
        }}
        aria-label="Unmatched criteria"
      >
        <InfoCircleIcon />
      </span>
      {show && (
        <Popup
          anchor={anchorRef.current ?? undefined}
          show={show}
          popupClass="k-popup"
          animate={false}
          anchorAlign={{ horizontal: 'right', vertical: 'center' }}
          popupAlign={{ horizontal: 'left', vertical: 'center' }}
        >
          <div
            style={{
              padding: '8px 10px',
              fontSize: 11,
              lineHeight: 1.55,
              color: '#1e293b',
              background: '#fff',
              border: '1px solid #e2e8f0',
              borderRadius: 6,
              boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
              maxWidth: 200,
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={() => setShow(true)}
            onMouseLeave={() => setShow(false)}
          >
            <strong style={{ display: 'block', marginBottom: 4, color: '#64748b', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Not matched:
            </strong>
            {unmatchedCriteria.map((c, i) => (
              <div key={i} style={{ color: '#475569' }}>• {c}</div>
            ))}
          </div>
        </Popup>
      )}
    </>
  );
}

function InfoCircleIcon() {
  return (
    <svg
      width="12" height="12" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}
